import filters from "./filters";

export default {
    state: {
        allItems: [],
        sortedArray: null,
        sortedType: null,
        max_price: null,
        min_price: null
    },
    mutations: {
        ALL_SEARCHED_ITEMS(state, data) {
            state.allItems = data.results;
            let priceArray = [];
            data.results.forEach(i => {
                priceArray.push(i.rates[0].totalRate)
            });
            let minPrice = Math.min.apply(null, priceArray);
            let maxPrice = Math.max.apply(null, priceArray);
            state.min_price = minPrice;
            state.max_price = maxPrice
        },
        SORT_ITEMS(state, sortType) {
            filters.state.filteredResults = null;
            if (sortType === 'by_price') {
                let sortPrice = state.allItems.sort((a, b) => {
                    let aIndex;
                    let bIndex;
                    a.rates.forEach((rate, index) => {
                        if (rate.isCheapestRate === true) {
                            aIndex = index
                        } else {
                            aIndex = 0
                        }
                    });
                    b.rates.forEach((rate, index) => {
                        if (rate.isCheapestRate === true) {
                            bIndex = index
                        } else {
                            bIndex = 0
                        }
                    });

                    return Number(a.rates[aIndex].totalRate - b.rates[bIndex].totalRate)
                });

                state.sortedArray = sortPrice

            } else if (sortType === 'by_rating') {
                let sortRating = state.allItems.sort((a, b) => {
                    return Number(b.starRating - a.starRating)
                });
                state.sortedArray = sortRating;
            }
            state.sortedType = sortType
        }
    },
    actions: {
        GET_ALL_SEARCHED_ITEMS(ctx, data) {
            ctx.commit('ALL_SEARCHED_ITEMS', data)
        },
        SORT_SEARCHED_ITEMS(ctx, sortType) {
            ctx.commit('SORT_ITEMS', sortType)
        }
    },
    getters: {}
}